import { updateMail } from '../helper/apiHelper.js'

export const deleteEmails = async (type, id) => {
    switch (type) {
        case "inbox":
        case "sent":
        case "important":
        case "category":
        case "spam":
            await deleteInbox(id);
            break;
        case "trash":
            await updateEmails('trash_delete', id);
            break;
        case "draft":
            await updateEmails('draft_delete', id);
            break;
        case "quicksent":
            await updateEmails('quicksent_delete', id);
            break;
        case "delete_category":
            await updateEmails(type, id);
            break;
        default:
            break;
    }
}

export const updateEmails = async (type, id) => {
    await updateMail(type, id);
}

async function deleteInbox(id) {
    await updateMail('delete', id);
}
